@if (!expanded) {
  <div class="cursor-pointer">
    <label>{{label}}</label>
    <div (click)="toggle()">
      <i class="far fa-plus-circle icon-color"></i>
      {{ 'DEFAULT_BUTTON_LABEL_VISA' | translate }}
      @if (nrOfSelectedFilters > 0) {
        <span class="fw-bold">({{ nrOfSelectedFilters }})</span>
      }
    </div>
  </div>
}
@if (expanded) {
  <div class="panel-body">
    <div class="panel-body-content">
      <ng-content></ng-content>
    </div>
    <i class="far fa-minus-circle icon-color cursor-pointer close-icon" (click)="toggle()"></i>
  </div>
}